var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyWaterInfrastructure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2679_732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6583 21.9063C42.6583 28.3124 41.0624 32.6208 34.7946 38.378C34.6773 38.4874 21.4844 49.7131 21.4844 49.7131C21.4844 49.7131 8.2363 38.2971 8.11895 38.1877C3.32597 33.973 0.318359 28.3124 0.318359 21.9063C0.318359 10.2126 9.79849 0.740234 21.4844 0.740234C33.1781 0.740234 42.6583 10.2126 42.6583 21.9063Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5642 38.6094C30.8763 38.6094 38.4253 31.0604 38.4253 21.7483C38.4253 12.4362 30.8763 4.88721 21.5642 4.88721C12.2521 4.88721 4.70312 12.4362 4.70312 21.7483C4.70312 31.0604 12.2521 38.6094 21.5642 38.6094Z",
    fill: "#5CDAF7",
    stroke: "#158AD1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3875 20.1145L21.6549 10.1802C21.566 10.0793 21.4088 10.0793 21.3199 10.1802L12.5872 20.1145C12.4605 20.2586 12.5628 20.4847 12.7545 20.4847H15.412C15.5353 20.4847 15.6351 20.5845 15.6351 20.7076V29.2773C15.6351 29.4004 15.7348 29.5002 15.8578 29.5002H27.1569C27.28 29.5002 27.3798 29.4004 27.3798 29.2773V20.7076C27.3798 20.5845 27.4797 20.4847 27.6027 20.4847H30.2201C30.4117 20.4847 30.5143 20.2586 30.3875 20.1145ZM24.5211 25.5077C23.7071 26.3084 22.7218 26.7087 21.5641 26.7087C20.4066 26.7087 19.421 26.3084 18.6073 25.5077C17.7936 24.7071 17.3868 23.7323 17.3868 22.5835C17.3868 22.0353 17.4933 21.5109 17.7066 21.0105C17.9198 20.5101 18.2222 20.0684 18.6139 19.6855L21.5641 16.7874L24.5145 19.6855C24.9061 20.0684 25.2086 20.5101 25.4217 21.0105C25.6349 21.5109 25.7416 22.0353 25.7416 22.5835C25.7416 23.7323 25.3346 24.7071 24.5211 25.5077Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2679_732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3399,
    height: 48.9729,
    fill: "white",
    transform: "translate(0.318359 0.740234)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyWaterInfrastructure);
export default __webpack_public_path__ + "static/media/grey-water-infrastructure.e2b8dd2c55049447d4d74e846459f2cf.svg";
export { ForwardRef as ReactComponent };